export const allowedFileTypes = [
  '.docx',
  '.doc',
  '.pdf',
  '.txt',
  '.rtf',
  '.md',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/msword',
  'application/pdf',
  'text/plain',
  'application/rtf',
  'text/markdown',
  'text/plain',
  'text/richtext',
  'text/rtf',
  'text/csv',
  'text/xml',
  'application/xml',
  'application/doc',
  'application/x-rtf',
  'application/x-soffice',
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.template',
  'application/vnd.ms-excel.sheet.macroEnabled.12',
  'application/vnd.ms-excel.template.macroEnabled.12',
  'application/vnd.ms-excel.addin.macroEnabled.12',
  'application/vnd.ms-excel.sheet.binary.macroEnabled.12',
];

export const allowedFileExtensions = ['.docx', '.doc', '.pdf', '.txt', '.rtf', '.md'];
